<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p style="color: #0e6ba9;" class="nombreBoton" @click="siguenteFlujo(data.item.idSolicitudEtapa, data.item)" >
      {{ data.item.nombrePaciente }}
    </p>
  </div>

</template>

<script>
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
  name: "BandejaLinkPacienteReplicaComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data() {
    return {
      motorServicio : new MotorService(),
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    siguenteFlujo(idSolicitudEtapa,item) {

      if (item.estatus === 'Finalizado'){
        this.$swal.fire({
          icon: "info",
          text: "Etapa finalizada",
        });
        return false;
      }

      const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }

      this.motorServicio
          .obtenerSiguenteFlujo(params)
          .then((respuesta) => {
            let url = respuesta.data.urlPantalla;
            if (respuesta.data.parametros.length > 0) {
              url = url + "/"+item.idPaciente+'/'+item.idPti+'/';
              respuesta.data.parametros.forEach((p, i) => {
                url = url + p.valor;
                if (i + 1 < respuesta.data.parametros.length) {
                  url = url + "/";
                }
              });
              url = url + "/" + respuesta.data.idEtapa;
            }
            this.$router.push(url);
          })
          .finally(() => {
            this.loader = false;
          });
    },
    putCambiarEstatusSolicitud(idSolicitudDiagnostico) {
      var params = {
        idSolicitudDiagnostico: idSolicitudDiagnostico,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };

      this.$http
        .put(
          this.$api +
            "replicas/bandeja/cambiarEstatusSolicitud?idSolicitudDiagnostico",
          params
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.nombreBoton {
  cursor: pointer;
}
.nombreBoton:hover {
  cursor: pointer;
  color: #0c69a7;
  font-weight: bold;
}
</style>
